import { SimpleGrid, Box, Heading, Text, Tag } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiSparkles } from 'react-icons/hi';
import { Link as RouterLink } from 'react-router-dom';

import LogoLoader from 'components/Loader/LogoLoader';
import { useFetchIntegrationList } from 'hooks/integrations/useFetchIntegrationList';

import { useAllowedReportList } from './useAllowedReportList';

const ReportsList: React.FC<unknown> = () => {
  const { t } = useTranslation(['common']);
  const { status: integrationListStatus } = useFetchIntegrationList();

  const { allowedReportData } = useAllowedReportList();

  if (integrationListStatus === 'loading') return <LogoLoader />;

  return (
    <SimpleGrid columns={{ base: 1, sm: 2, lg: 3, xl: 4 }} spacing={{ base: 3, sm: 10 }}>
      {allowedReportData.map((item: any) => {
        return (
          <Box
            as={RouterLink}
            to={item.pathname}
            borderRadius="lg"
            p="5"
            bg="gray.100"
            cursor="pointer"
            _hover={{ boxShadow: 'lg' }}
            key={item.name}
          >
            <Heading as="h3" size="sm" mb="2">
              {item.name || ''}{' '}
            </Heading>
            <Text>{item.description}</Text>
            {item.isNew ? (
              <Tag
                colorScheme="secondary"
                color="secondary.700"
                fontWeight="bold"
                w="fit-content"
                mt={1}
                display="flex"
                gridGap={1}
                alignItems="center"
              >
                {t('common:new')}
                <HiSparkles />
              </Tag>
            ) : null}
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default ReportsList;
